<!--<pane-back-button text="Close" (onClose)="onClose()"></pane-back-button>-->

<div class="search-results mt-4 ">
    <div class="d-flex align-items-center ms-3">
        <fa-icon (click)="close()" [icon]="iconService.faIconsSolid.faArrowLeft" class="toolbar-icon-btn"></fa-icon>
        <div *ngIf="searchTerm" class="mx-3 title text-bold text-large">Search results</div>
        <div *ngIf="!searchTerm" class="mx-3 title text-bold text-large text-muted">Start typing to search</div>
    </div>

    <div class="results list-group list-group-flush">
        @for (user of displayedResults.users; track user.id) {
            <search-result-user [user]="user"></search-result-user>
        } @empty {
        }
        <a *ngIf="searchResults.users.length > 3 && !bShowAllUsers"
           (click)="showAllUsers(true)"
           class="pointer result list-group-item list-group-item-action">
            Show more
        </a>
        @for (entity of displayedResults.entities; track entity.id) {
            <search-result-entity [entity]="entity"></search-result-entity>
        } @empty {
        }
        <div *ngIf="searchResults.entities.length > 3 && !bshowAllEntities"
             (click)="showAllEntities(true)"
             class="pointer result list-group-item list-group-item-action">
            Show more
        </div>
    </div>
</div>